module.exports = __webpack_public_path__ + "img/2.dbdb51a9.png";